const initialState =
 {  
    loading: false, 
    error:false,
    message:"",
    data:[],
    item:null,
    connect:false,
    socket:null,
 }

export default (state = initialState, action) => {
    switch (action.type) {
        case "IS_CONNECT_DAY":
            return { ...state,connect:action.payload};
        case "SET_SOCKET_DAY":
            return { ...state,socket:action.payload};
        default:
    }
    return state;
}
